import React from 'react';
import {
  SelectInput,
  ReferenceInput,
  required, TextInput,
  maxLength,
  FormTab,
} from 'react-admin';

import { isProductiveRule } from './regla-utils';
import SgxDateInput from '../components/sgxDateInput';

const ReglaEditForm = (props) =>  (
      <FormTab label="resources.regla.tabs.general" path="regla" {...props}>
        <TextInput source="descripcion" validate={[required()]} disabled={isProductiveRule(props)}/>
        <ReferenceInput
          source="idTipoRegla"
          reference="tipos-regla"
          validate={[required()]}
          disabled={true}
          >
          <SelectInput optionText="descripcion" optionValue="id" />
        </ReferenceInput>
        <TextInput source="nroTicket" validate={[maxLength(30)]} disabled={isProductiveRule(props)}/>
        <TextInput source="descripcionCompleta" validate={[required()]} disabled={isProductiveRule(props)}/>
        <ReferenceInput
          source="idCodigoRechazo"
          reference="codigo-rechazo"
          validate={[required()]}
          disabled={isProductiveRule(props)}
          filter={{ deleted: false }}
          >
          <SelectInput optionText="descripcion" optionValue="id" />
        </ReferenceInput>
        <ReferenceInput
          source="idGrupoRegla"
          reference="grupo-regla"
          validate={[required()]}
          disabled={isProductiveRule(props)}
          filter={{ deleted: false }}
          >
          <SelectInput optionText="descripcion" optionValue="id" />
        </ReferenceInput>

        <ReferenceInput source="estado" reference="estado-regla" validate={[required()]} disabled={isProductiveRule(props)}>
          <SelectInput optionText="descripcion" optionValue="id" validate={[required()]} />
        </ReferenceInput>
        <SgxDateInput source="desde" label="resources.regla.fields.desde" validate={[required('Requerido')]} />
        <SgxDateInput source="hasta" label="resources.regla.fields.hasta" validate={[required('Requerido')]} />
        </FormTab>
      );

export default ReglaEditForm;
